import React, { Component } from 'react'
import QrReader from 'react-qr-reader'

export default class QrScanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setPermission: true,
            cameraState: "WAITING",
        }
    }

    componentDidMount() {
        const comp = this;
        if(navigator?.mediaDevices) {
            navigator.mediaDevices.getUserMedia({ video: true })
            .then(this.streamFound)
            .catch(function (error) {
                comp.setState({ cameraState: "ERROR" })
                console.error("Device (camera) access checks failed: ", error);
            });
        } else {
            this.setState({ cameraState: "ERROR" })
        }
        if (this.props.cameraAsked) {
            this.props.cameraAsked()
        }
    }

    streamFound = (stream) => {
        const streamTrack = stream.getTracks()[0]
        // Assign `stopCamera` so the track can be stopped once component is cleared
        this.stopCamera = streamTrack.stop.bind(streamTrack)
        console.info('Device (camera) access checks success', stream);
        console.log("stream acquired")
        this.stopCamera()
        setTimeout(() => {
            console.log("opening qr")
            this.setState({ cameraState: "MOUNTED" })
        }, 100)

    }

    componentWillUnmount() {
        if (this.stopCamera) {
            this.stopCamera()
        }
    }

    handleScan = data => {

        if (data) {
            this.props.onDetect(data);
        }
    }
    handleError = (err) => {
        this.props.onError(err)
    }

    render() {
        const { errorRender, waitingRender, torch = false } = this.props

        switch (this.state.cameraState) {
            case "WAITING":
                if (waitingRender)
                    return waitingRender()
                break
            case "ERROR":
                if (errorRender)
                    return errorRender()
                break
            case "MOUNTED":
            default:
                return <div className='mb-1' style={{ alignItems: 'center' }}>
                    <QrReader
                        key={'qr-reader-torch-'+torch}
                        delay={1000}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        legacyMode={false}
                        torch={torch}
                        style={{ width: '100%' }}
                    />
                </div>

        }
        return <></>
    }
}
